import React, { useEffect, useState } from 'react'
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { get } from '../../helper/helper_api';
import { Link } from 'react-router-dom';
import moment from 'moment';
export default function Blog() {

    const [data, setData] = useState(undefined);
    useEffect(() => {
        getData()
    }, [])



    const getData = () => {
        get(`blog`)
            .then(res => {
                if (res?.statusCode == 200) {
                    setData(res?.data)

                }
            }).catch(err => {
                console.log(err)
            })

       
    }


    const parseTitle = (title) => {
        let str = title?.toLowerCase();
        str = str?.split(" ").join("-");
        return str;
    }


    return (
        <>
            <section class="page-title-center-alignment cover-background top-space-padding" style={{ backgroundImage: `url(images/demo-decor-store-title-bg.jpg)` }}>

                <div class="container">

                    <div class="row">

                        <div class="col-12 text-center position-relative page-title-extra-large">

                            <h1 class="alt-font d-inline-block fw-700 ls-minus-05px text-base-color mb-10px mt-3 md-mt-50px">blog</h1>

                        </div>

                        <div class="col-12 breadcrumb breadcrumb-style-01 d-flex justify-content-center">

                            <ul>

                                <li><a href="demo-decor-store.html">Home</a></li>

                                <li>blog</li>

                            </ul>

                        </div>

                    </div>

                </div>

            </section>
            <section>

                <div class="container">

                    <div class="row">

                        <div class="col-12 px-0">

                            <ul class="col xl-grid-4col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-double-extra-large" data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                                <li class="grid-sizer"></li>

                                {/* <!-- start blog item --> */}

                                <ResponsiveMasonry
                                    columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 4 }}
                                >

                                    <Masonry>
                                        {
                                            data?.map((item, index) => {
                                                return (
                                                    <div class="card bg-transparent border-0 h-100">

                                                        <div class="blog-image position-relative overflow-hidden border-radius-4px">

                                                            <Link to={`${parseTitle(item?.titleShort)}`}><img src={item?.image} alt="" /></Link>

                                                        </div>

                                                        <div class="card-body px-0 pt-30px pb-30px xs-pb-15px">

                                                            <span class="fs-13 text-uppercase d-block mb-5px fw-500"><Link to={`${parseTitle(item?.titleShort)}`} class="blog-date">{moment(item?.updatedAt).format('MMMM Do YYYY')}</Link></span>

                                                            <Link to={`${parseTitle(item?.titleShort)}`} class="card-title alt-font fw-600 fs-17 lh-30 text-dark-gray d-inline-block w-95 sm-w-100">{item?.titleShort}</Link>

                                                        </div>

                                                    </div>
                                                )
                                            })
                                        }
                                    </Masonry>
                                </ResponsiveMasonry>


                            </ul>

                        </div>

                        <div class="col-12 mt-3 sm-mb-3 d-flex justify-content-center" data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                            <ul class="pagination pagination-style-01 fs-13 fw-500 mb-0">

                                <li class="page-item"><a class="page-link" href="#"><i class="feather icon-feather-arrow-left fs-18 d-xs-none"></i></a></li>

                                <li class="page-item"><a class="page-link" href="#">01</a></li>

                                <li class="page-item active"><a class="page-link" href="#">02</a></li>

                                <li class="page-item"><a class="page-link" href="#">03</a></li>

                                <li class="page-item"><a class="page-link" href="#">04</a></li>

                                <li class="page-item"><a class="page-link" href="#"><i class="feather icon-feather-arrow-right fs-18 d-xs-none"></i></a></li>

                            </ul>

                        </div>

                    </div>

                </div>

            </section>
        </>
    )
}
